//#region src/Navbar/Navbar.lib.ts
const matchPath = (options, pathname) => {
	const { path, end = true, caseSensitive = false } = options;
	const flags = caseSensitive ? "" : "i";
	const paramNames = [];
	const regexPath = path.split("/").map((segment) => {
		if (segment.startsWith(":")) {
			paramNames.push(segment.slice(1));
			return "([^/]+)";
		}
		return segment.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
	}).join("/");
	const regex = new RegExp(`^${regexPath}${end ? "$" : ""}`, flags);
	const match = pathname.match(regex);
	if (!match) return null;
	const params = {};
	paramNames.forEach((name, index) => {
		params[name] = match[index + 1] ?? "";
	});
	return {
		pathname: match[0],
		params
	};
};
const getSystemType = () => {
	const value = import.meta.env?.VITE_SYSTEM_TYPE;
	if (value === "GGE" || value === "RZD" || value === "EKPTD" || value === "RAD") return value;
	return "RZD";
};
//#endregion
export { getSystemType, matchPath };

//# sourceMappingURL=Navbar.lib.js.map